import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { totalcountapi } from '../../ApiUrl';
import axios from 'axios';
export const token = sessionStorage.getItem("accessToken")

const headers = {
  Authorization: `Bearer ${token}`,
};
function Feedback() {
  const [totalValue, setTotalValue] = useState({})
  const [loading, setLoading] = useState(true);
  const totalapi = async () => {
    try {
      const res = await axios.get(totalcountapi, { headers })
      setTotalValue(res.data.data)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }
  useEffect(() => {
    totalapi()
  })
  const cards = [

    {
      id: 1,
      name: "Contact",
      link: "/contact",
      icon: "headset",
      number: loading ? "loading" : totalValue.totalContact,
    },
    {
      id: 2,
      name: "Complaint",
      link: "/complaint",
      icon: "question-octagon-fill",
      number: loading ? "loading" : totalValue.totalComplaint,
    },
    {
      id: 3,
      name: "Student Feedback",
      link: "/studentFeedback",
      icon: "chat-left-fill",
      number: loading ? "loading" : totalValue.totalStudentFeedback,
    },
    {
      id: 4,
      name: "Alumni Feedback",
      link: "/alumniFeedback",
      icon: "chat-left-fill",
      number: loading ? "loading" : totalValue.totalAlumniFeedback,
    },
    {
      id: 5,
      name: "Teacher Feedback",
      link: "/teacherFeedback",
      icon: "chat-left-fill",
      number: loading ? "loading" : totalValue.totalTeacherFeedback,
    },
    {
      id: 6,
      name: "Parents Feedback",
      link: "/parentsFeedback",
      icon: "chat-left-fill",
      number: loading ? "loading" : totalValue.totalParentsFeedback,
    },
    {
      id: 7,
      name: "Entrance Form",
      link: "/form",
      icon: "card-list",
      number: loading ? "loading" : totalValue.totalForm,
    },

  ]
  return (
    <>
      <div className="row justify-content-start">
        {loading && (
          <>
            {Array.from({ length: 9 }).map((_, index) => (
              <div key={index} className='col-lg-4 col-6'>
                <div className='p-2'>
                  <Skeleton height={100} />
                </div>
              </div>
            ))}
          </>
        )}
        {!loading && (
          cards.map((_) => (
            <div className="col-lg-4 col-6 my-2" key={_.id}>
              <Link to={_.link}> <div className={`d-flex justify-content-between text-dark p-3 rounded shadow-sm border`}>
                <div className='content-center'>
                  <div>
                    <i className={`bi bi-${_.icon} fs-2`}></i>
                    <div className='text-primary'>{_.name}</div>
                  </div>
                </div>
                <div className='content-center'>
                  <div className='text-end'>
                    <div className='fs-1'>{_.number}</div>
                  </div>
                </div>
              </div>
              </Link>
            </div>
          ))
        )}

      </div>
    </>
  )
}

export default Feedback